import Colors from '@/constants/Colors';
import MediaQueryBreakpoints from '@/constants/MediaQueryBreakpoints';
import styled from 'styled-components';

export const StyledSubscriptions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;

  @media only screen and (max-width: ${MediaQueryBreakpoints.md}) {
    flex-direction: column;
  }
  justify-content: space-between;
  gap: 20px;
  margin-top: 20px;

  .small-text {
    font-size: 12px;
  }

  .pricing-container {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    border-radius: 10px;
    box-shadow: 0px 1px 4px ${Colors.boxShadowGray};
    border: 1px solid ${Colors.lighterGray};
    background-color: white;
  }

  .most-popular-container {
    position: relative;

    .text-container {
      position: absolute;
      top: -10px;
      width: 100%;
      text-align: center;
    }

    .text {
      background-color: ${Colors.pink};
      padding: 10px;
      border-radius: 30px;
      text-transform: uppercase;
      color: white;
    }
  }

  .pricing-wrapper {
    padding: 20px;
  }

  .separator {
    border: 0.5px solid ${Colors.boxShadowGray};
  }

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .subheader {
    display: flex;
    align-items: center;
    margin-top: 15px;
    margin-bottom: 20px;

    .price {
      margin-right: 5px;
    }

    .description {
      flex-grow: 1;
    }
  }

  .button-container {
    display: flex;
    align-items: center;
    justify-content: space-around;
    gap: 20px;
    width: 100%;
    margin-top: 20px;

    .ant-btn {
      /* padding-left: 50px;
      padding-right: 50px; */
    }
  }

  .features-container {
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    padding: 0 10px;

    .feature {
      display: flex;
      gap: 10px;

      margin-top: 15px;
      margin-bottom: 5px;
      list-style-image: none;
      font-size: 16px;
      color: ${Colors.textDark};

      .icon {
        width: 20px;
      }

      .content {
        padding-top: 1px;
        .ant-typography {
          color: ${Colors.textDark};
        }

        .small {
          font-size: 14px;
        }

        &.bold {
          font-weight: bold;
        }
      }

      &.disabled {
        color: ${Colors.lighterGray};
        .content {
          .ant-typography {
            color: ${Colors.lighterGray};
          }
        }
      }
    }

    .info {
      font-size: 16px;
    }
  }
`;

export const StyledTitleWithLanguageSelector = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  gap: 20px;
  margin-bottom: 20px;

  .first-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  @media only screen and (max-width: ${MediaQueryBreakpoints.md}) {
    flex-direction: column;
    margin-top: 40px;

    .first-row {
      flex-direction: column;
      align-items: stretch;
      gap: 20px;
      margin-bottom: 20px;
    }
  }
`;

export const StyledSubscriptionLanguageSelector = styled.div`
  display: flex;
  gap: 10px;

  .language-buttons {
    display: flex;
    gap: 10px;

    .ant-btn {
      &.selected {
        border-color: ${Colors.primary};
      }

      .button-text {
        display: flex;
        align-items: center;
        gap: 5px;
      }
    }

    @media only screen and (max-width: ${MediaQueryBreakpoints.sm}) {
      flex-direction: column;

      button {
        flex: 1;
        .button-text {
          justify-content: center;
        }
      }
    }
  }
`;
